export const GET_DOCUMENT_TEMPLATE_PACKAGES = gql`
  query GET_DOCUMENT_TEMPLATE_PACKAGES($searchTerm: String) {
    documentTemplatePackages(searchTerm: $searchTerm) {
      documentTemplatePackageId
      packageName
      createdAt
      documentTemplates {
        documentTemplateId
        documentName
        documentCategory
      }
    }
  }
`

export const GET_DOCUMENT_TEMPLATE_PACKAGE = gql`
  query GET_DOCUMENT_TEMPLATE_PACKAGE($documentTemplatePackageId: String!) {
    documentTemplatePackage(
      documentTemplatePackageId: $documentTemplatePackageId
    ) {
      documentTemplatePackageId
      packageName
      documentTemplates {
        documentTemplateId
        documentName
        documentCategory
        userStatus
        signers
        signingToolRefId
      }
    }
  }
`
export const SIGN_PACKAGE = gql`
  mutation SIGN_PACKAGE(
    $documentTemplatePackageId: String!
    $applicantId: String!
    $applicantEmail: String!
  ) {
    signPackage(
      documentTemplatePackageId: $documentTemplatePackageId
      applicantId: $applicantId
      applicantEmail: $applicantEmail
    )
  }
`

export const SIGN_MULTIPLE_PACKAGES = gql`
  mutation SignMultiplePackages(
    $applicantId: String!
    $applicantEmail: String!
    $documentTemplatePackageIds: [String!]!
    $companySignerEmail: String
  ) {
    signMultiplePackages(
      applicantId: $applicantId
      applicantEmail: $applicantEmail
      documentTemplatePackageIds: $documentTemplatePackageIds
      companySignerEmail: $companySignerEmail
    ) {
      packages {
        documentTemplatePackageId
        success
        errorMsg
        successMsg
      }
    }
  }
`

export const ADD_DOCUMENT_TEMPLATE_PACKAGE = gql`
  mutation ADD_DOCUMENT_TEMPLATE_PACKAGE(
    $input: AddDocumentTemplatePackageInput!
  ) {
    addDocumentTemplatePackage(input: $input) {
      documentTemplatePackageId
      packageName
      documentTemplates {
        documentTemplateId
        documentName
      }
    }
  }
`

export const UPDATE_DOCUMENT_TEMPLATE_PACKAGE = gql`
  mutation UPDATE_DOCUMENT_TEMPLATE_PACKAGE(
    $documentTemplatePackageId: String!
    $input: UpdateDocumentTemplatePackageInput!
  ) {
    updateDocumentTemplatePackage(
      documentTemplatePackageId: $documentTemplatePackageId
      input: $input
    ) {
      documentTemplatePackageId
      packageName
    }
  }
`

export const DELETE_DOCUMENT_TEMPLATE_PACKAGE = gql`
  mutation DELETE_DOCUMENT_TEMPLATE_PACKAGE(
    $documentTemplatePackageId: String!
  ) {
    deleteDocumentTemplatePackage(
      documentTemplatePackageId: $documentTemplatePackageId
    ) {
      documentTemplatePackageId
    }
  }
`

export const ADD_DOCUMENT_TEMPLATE = gql`
  mutation ADD_DOCUMENT_TEMPLATE($input: AddDocumentTemplateInput!) {
    addDocumentTemplate(input: $input) {
      documentTemplateId
      documentName
    }
  }
`

export const DISCONNECT_DOCUMENT_TEMPLATE = gql`
  mutation DISCONNECT_DOCUMENT_TEMPLATE(
    $documentTemplatePackageId: String!
    $documentTemplateId: String!
  ) {
    disconnectDocumentTemplate(
      documentTemplatePackageId: $documentTemplatePackageId
      documentTemplateId: $documentTemplateId
    ) {
      documentTemplatePackageId
    }
  }
`

export const CONNECT_DOCUMENT_TEMPLATE = gql`
  mutation CONNECT_DOCUMENT_TEMPLATE(
    $documentTemplatePackageId: String!
    $documentTemplateId: String!
  ) {
    connectDocumentTemplate(
      documentTemplatePackageId: $documentTemplatePackageId
      documentTemplateId: $documentTemplateId
    ) {
      documentTemplatePackageId
    }
  }
`

export const BULK_SIGN_PACKAGE = gql`
  mutation BulkSignPackage(
    $applicants: [String!]!
    $documentTemplatePackageId: String!
  ) {
    bulkSignPackages(
      applicants: $applicants
      documentTemplatePackageId: $documentTemplatePackageId
    ) {
      applicants {
        applicantId
        success
        errorMsg
        successMsg
      }
    }
  }
`
